import type { RemovableRef } from '@vueuse/core'
import { SortOption } from '../helper/sort'

const m = {
  string: (d?: string): ConfigString => ({ type: 'string', default: d ?? '' }),
  number: (d?: number): ConfigNumber => ({ type: 'number', default: d ?? 0 }),
  boolean: (d?: boolean): ConfigBoolean => ({ type: 'boolean', default: d ?? false }),
  enum: <T>(d: T): ConfigEnum<T> => ({ type: 'enum', default: d }),
}

const Config = {
  treeSorting: m.enum <SortOption>(SortOption.TypeAsc),
//   test: m.string('example'),
}

interface ConfigValue<A extends string, B> {
  type: A
  default: B
}

interface ConfigString extends ConfigValue<'string', string> {}
interface ConfigNumber extends ConfigValue<'number', number> {}
interface ConfigBoolean extends ConfigValue<'boolean', boolean> {}
interface ConfigEnum<T> extends ConfigValue<'enum', T> {}

type UseUserConfig = {
  [key in keyof typeof Config]: RemovableRef<typeof Config[key]['default']>;
}

export function useUserConfig(): UseUserConfig {
  const config = {} as UseUserConfig
  for (const key of Object.keys(Config)) {
    console.log(key, Config[key as keyof UseUserConfig], Config);
    (config as any)[key] = useLocalStorage(`config.${key}`, Config[key as keyof UseUserConfig].default)
  }
  // console.log(config)

  return config
}
